import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const VISITOR_KEY = "loudar_visitor_id";

const getVisitorId = () => {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        (crypto?.randomUUID?.() ?? "") ||
        `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
  }
};

export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    const visitor_id = getVisitorId();
    const referrer = document.referrer || null;
    // Fire and forget — never blocks UI
    api
      .post("/track", { path, visitor_id, referrer })
      .catch(() => {
        /* silent — analytics must never break UX */
      });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
